import { jsonMember, jsonObject } from 'typedjson';
import { dateSerializer } from '@core/json/serializers/date-serializer';

@jsonObject
export class RegulationCollectionFilterRequest {
  @jsonMember name?: string;
  @jsonMember({ serializer: dateSerializer() }) createdAtFrom?: Date;
  @jsonMember({ serializer: dateSerializer() }) createdAtTo?: Date;
}
